import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { FileOutput } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

export const DocumentGeneratorNode = memo(({ data, selected }: NodeProps) => (
    <BaseNodeUI
        title={data?.label || 'Document Generator'}
        icon={FileOutput}
        colorClass="from-pink-500 to-pink-700"
        bgClass="bg-gradient-to-br from-pink-500 to-pink-700"
        selected={selected}
        isRunning={data?.executionStatus === 'Running'}
        executionStatus={data?.executionStatus}
        isSource={false}
        isTarget={true}
        rowsProcessed={data?.rowsAffected}
    />
));
DocumentGeneratorNode.displayName = 'DocumentGeneratorNode';
export default DocumentGeneratorNode;
